import React from "react";
import "./index.m.css";

export const SpinnerLoader = () => {
  return (
    <div styleName="container">
      <div styleName="loader" />
    </div>
  );
};
